module.exports = __webpack_public_path__ + "img/robot_num.1ab27c0a.png";